/**
 * Firestore / Performance write Local Storage metadata even with memoryLocalCache.
 * Auth signOut does not remove these. Clear them on logout only — never touch
 * firebase:authUser* / Auth IndexedDB (needed for refresh session).
 */
export function clearFirestoreSdkLocalStorage(): void {
  try {
    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (
        key.startsWith("firestore_") ||
        key.startsWith("@firebase/performance")
      ) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    /* private mode / quota */
  }
}
